import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { environment } from 'src/environments/environment';
// import { AppConfig, APP_CONFIG } from 'app/app-config.module';

@Injectable({
	providedIn: 'root',
})
export class EmployeeUsersService {
	constructor(private dataService: OldDataService, private http: HttpClient) {}

	deactiveUser(user_id: any) {
		const url = `${environment.api}user/${user_id}/deactivate_user`;
		return this.http.get(url);
	}

	activateUser(user_id: any) {
		const url = `${environment.api}user/${user_id}/activate_user_by_id`;
		return this.http.get(url);
	}

	deactivateUserAdmin(user_id: any) {
		const url = `${environment.api}user/${user_id}/deactivate_user_admin`;
		return this.http.get(url);
	}

	activateUserAdmin(user_id: any) {
		const url = `${environment.api}user/${user_id}/activate_user_admin`;
		return this.http.get(url);
	}

	activateUserDBreset(user_id: any) {
		const url = `${environment.api}user/${user_id}/activate_db_reset`;
		return this.http.get(url);
	}

	deactiveUserDBreset(user_id: any) {
		const url = `${environment.api}user/${user_id}/deactivate_db_reset`;
		return this.http.get(url);
	}

	activateUserCaller(user_id: any) {
		const url = `${environment.api}user/${user_id}/activate_caller`;
		return this.http.get(url);
	}

	deactivateUserCaller(user_id: any) {
		const url = `${environment.api}user/${user_id}/deactivate_caller`;
		return this.http.get(url);
	}
}
